export interface BdUiSaltInputConfig {
  /** Title displayed above the input */
  title: string;
  /** Label for the input field */
  inputLabel: string;
  /** Label for the generate button */
  generateButtonLabel: string;
  /** Primary hint text (shown below input) */
  primaryHint: string;
  /** Secondary hint text (shown below primary hint) */
  secondaryHint: string;
  /** Length of generated random salt */
  generatedSaltLength: number;
  /** Show/hide the info hints */
  showHints: boolean;
}

export const BD_UI_SALT_INPUT_CONFIG_DEFAULT: BdUiSaltInputConfig = {
  title: 'Salt für datenschutzkonformes Hashing',
  inputLabel: 'Salt-Wert',
  generateButtonLabel: 'Zufälligen Salt generieren',
  primaryHint:
    'Innerhalb Ihrer Virtuellen Klinik sollten Sie immer denselben Salt verwenden, damit Sie auch später noch Fälle derselben Person zuverlässig verknüpfen können. Nur wenn der Salt konstant bleibt, ist eine interne Zuordnung über Hashwerte möglich.',
  secondaryHint:
    'Der Salt wird nur lokal verwendet und niemals mit den Daten übertragen.',
  generatedSaltLength: 10,
  showHints: true,
};
